//***********************************************
//
// options for selection.js based on the Codepen:
// https://codepen.io/liquidvisual/pen/NzqzxN
//
//***********************************************

export default {
    // Class for the selection-area-element
    class: 'selection-area',

    selectedClass: 'active',

    // px, how many pixels the point should move before starting the selection
    startThreshold: 10,

    // Disable the selection functionality for touch devices
    disableTouch: false,

    // Enable single-click selection
    singleClick: true,

    // Query selectors from elements from which the siblings can be selected
    // containers: [],

    // Query selectors from elements which can be selected
    selectables: ['.file-boundary'],

    // Query selectors for elements from where a selection can be start
    startareas: ['.icon-view'],

    // Query selectors for elements which will be used as boundaries for the selection
    boundaries: ['.icon-view'],

    //------------------------------------------
    // MOVE
    //------------------------------------------

    // this event is triggered on mouse drag, not move
    onMove(evt) {
        console.log('onMove');
        // Get elements added or removed
        const selectedElements = evt.selectedElements;
        const removedElements = evt.changedElements.removed;

        // Add a custom class to the elements which where selected.
        selectedElements.forEach(s => s.classList.add(this.options.selectedClass));

        // Remove the class from elements which where removed
        // since the last selection
        removedElements.forEach(s => s.classList.remove(this.options.selectedClass, 'selected'));
    }
};